import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { ArtemisCocPreviewPageArtaComponent } from 'src/app/artemis/artemis-inbox-page/artemis-charter-inbox-page-arta/artemis-coc-preview-page-arta/artemis-coc-preview-page-arta.component';

@Component({
  selector: 'app-agency-submitted-charter',
  templateUrl: './agency-submitted-charter.component.html',
  styleUrls: ['./agency-submitted-charter.component.scss']
})
export class AgencySubmittedCharterComponent implements OnInit {
  @Input('agency_id') agency_id: any;
  @Input('isAdmin') isAdmin: any;
  @Input('isAgencyMember') isAgencyMember: any;
  results: any = []
  //mat table paginator
  displayedColumns: string[] = ['datesubmitted', 'ccversion'];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  //number formatting
  ordinals: string[] = ['th', 'st', 'nd', 'rd'];



  constructor(private router: Router, public dialog: MatDialog, private afs: AngularFirestore, private http: HttpClient,) { }

  ngOnInit(): void {
    this.loadCCbyAgency();
  }


  loadCCbyAgency() {

    this.afs.collection('citizens-charter-phase-02', filter =>
      filter.where("fromAgencyId", "==", this.agency_id)
        .where('status', '!=', 'POSTED')
        .orderBy("dateSubmitted", 'desc'))
      .snapshotChanges()
      .pipe(tap((data: any) => {

        //reset tables berofe adding snapshots
        this.results = []
        data.forEach((info: any) => {
          let item: any = info.payload.doc.data();
          item.id = info.payload.doc.id;
          this.results.push(item)


        })

        this.dataSource = new MatTableDataSource(this.results)
        this.resetSortPage()
      }))
      .subscribe()
  }

  resetSortPage() {
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
  }

  sortChange(sort: Sort) {
    const data = this.results.slice()
    // console.log('sort.active',sort.active)
    // console.log('sort.direction',sort.direction)
    if (!sort.active || sort.direction === '') {
      this.results = data
      return;
    }
    this.results = data.sort((a: any, b: any) => {
      // console.log('results',this.results)
      const isAsc = sort.direction === 'asc'
      switch (sort.active) {

        case 'datesubmitted':
          return this.compare(a.dateSubmitted, b.dateSubmitted, isAsc)

        default:
          return null
      }
    })
    this.dataSource = new MatTableDataSource<any>(this.results)
    this.resetSortPage()

  }
  //sort data 
  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  ViewCCDocument(data: any) {

    if (data.id) {

      // console.log("CC Dat",data);
      this.router.navigate(["/artemis/citizen-charter/view/report/"], {
        queryParams: {
          cc_id: data.id,
          edition: data.edition,
          submittedonly: true
        }
      })


      //this.checkDocumentExist(data)
    }
  }

  transform(n: number, year: string, keepNumber: boolean = true) {
    let v = n % 100;
    return year + " " + (keepNumber ? n : '') + (this.ordinals[(v - 20) % 10] || this.ordinals[v] || this.ordinals[0]) + " Edition";
  }
}
